module.exports = __webpack_public_path__ + "img/exthumbnail.ff1e3a38.svg";